import { computed } from "vue";
import store from "@/store";

export default function useStageconfig() {
  const config = computed(() => {
    // @ts-ignore
    return store.state.stageconfig.config;
  });

  return {
    config
  };
}
